import {compareStringsByCodePoints} from "../../js/util/CommonUtils.js";
import EicExtractionPropsWithDetectorType from "./EicExtractionPropsWithDetectorType.js";

export default class SubstanceExtractionParams {
    /** @type {SubstanceJson} */
    #substance;
    /** @type {EicExtractionPropsWithDetectorType[]} extractionProps */
    #extractionProps;

    /**
     * @param {SubstanceJson} substance
     * @param {EicExtractionPropsWithDetectorType[]} extractionProps
     */
    constructor(substance, extractionProps) {
        if (substance == null)
            throw new Error("Substance is null");
        this.#substance = substance;
        this.#extractionProps = extractionProps.map(p => p.copy())
            .sort((a, b) =>
                compareStringsByCodePoints(a.displayName, b.displayName));
    }

    /** @param {EicExtractionPropsWithDetectorType} extractionProps */
    put(extractionProps) {
        const index = this.#extractionProps.findIndex(p => p.ionMode.name === extractionProps.ionMode.name
            && p.measuringMode === extractionProps.measuringMode);
        if (index === -1)
            this.#extractionProps.push(extractionProps);
        else
            this.#extractionProps[index] = extractionProps;
    }

    /**
     * @param {string} ionMode
     * @param {string} measuringMode
     * @returns {EicExtractionPropsWithDetectorType}
     */
    getByIonMode(ionMode, measuringMode) {
        return this.#extractionProps.find(p => p.detectorMode.ionMode.name === ionMode && p.detectorMode.measuringMode === measuringMode);
    }

    /** @returns {EicExtractionPropsWithDetectorType[]} */
    get props() {
        return this.#extractionProps;
    }

    /** @returns {SubstanceJson} */
    get substance() {
        return this.#substance;
    }

    equals(other) {
        if (this === other) return true;
        if (!(other instanceof SubstanceExtractionParams)) return false;
        return this.#substance.hasSameComposition(other.#substance)
            && this.#extractionProps.length === other.#extractionProps.length
            && this.#extractionProps.every((p, i) => p.equals(other.#extractionProps[i]));
    }

    toServerJson() {
        const json = [];
        this.#extractionProps.forEach(p => json.push(p.toServerJsonWithIonConfig()));
        return json;
    }

    static parseServerJson(substance, jsonArray) {
        return new SubstanceExtractionParams(substance, jsonArray.map(json => EicExtractionPropsWithDetectorType.parseServerJson(json)));
    }

    static default(substance) {
        return new SubstanceExtractionParams(substance, []);
    }
}